import moment from "moment";

export function tripsOnThisDay(allTrips, thisDay) {
  return allTrips && allTrips.filter((trip) => {
      const depDate = new moment(trip.departureDate);
      const retDate = new moment(trip.returningDate);
      return depDate <= thisDay && retDate > thisDay;
    })

}